<template>
    <v-container fluid class="pa-0">
        <v-card class="mr-3 ml-3 mb-3">
            <v-card-title>{{ !id ? 'Создание новости' : `Редактор новости №${id}` }}</v-card-title>

            <v-card-text v-if="formLoading" class="d-flex justify-center pb-8">
                <v-progress-circular
                    indeterminate
                    color="green"
                ></v-progress-circular>
            </v-card-text>

            <div v-else>
                <v-card-text class="d-flex flex-column pt-0">
                    <v-row>
                        <v-col cols="3">
                            <v-select
                                v-model="softType"
                                :items="softTypes"
                                item-text="name"
                                item-value="id"
                                label="Тип софта"
                            ></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="title"
                                label="Заголовок"
                                single-line
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-menu
                                v-model="menu"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formattedDate"
                                        label="Дата публикации"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateString"
                                    :min="minDate"
                                    no-title
                                    color="green"
                                    scrollable
                                    locale="ru-RU"
                                    :first-day-of-week="1"
                                    @input="updateDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="3">
                            <v-select
                                v-model="newType"
                                :items="newTypes"
                                item-text="name"
                                item-value="id"
                                label="Тип новости"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <text-wysiwyg-editor-field v-model="newText" :key="keyCrutch" />
                    <div class="d-flex align-center justify-space-around mt-4">
                        <v-btn
                            color="warning"
                            style="color: white !important;"
                            :disabled="btnLoading"
                            @click="addPicture"
                        >
                            <v-icon>mdi-picture</v-icon>
                            Прикрепить изображение
                        </v-btn>
                        <input type="file" ref="fileInput" @change="onFileChange" accept="image/*" style="display: none;" /> <!--Диалог проводника-->
                        <v-btn
                            color="red"
                            style="color: white !important;"
                            :disabled="btnLoading || !picture"
                            @click="picture = ''"
                        >
                            Удалить изображение
                        </v-btn>
                    </div>
                    <div class="d-flex justify-center mt-4" v-if="picture">
                        <img alt="Изображение новости" :src="picture" style="max-width: 100%; border-radius: 4px;" />
                    </div>
                </v-card-text>
    
                <v-card-actions class="px-4 pt-0">
                    <v-checkbox
                        v-model="important"
                        label="Важная новость"
                        color="green"
                    ></v-checkbox>
                    <v-spacer />
                    <v-btn
                        color="green"
                        :disabled="softType === null || !title || newType === null || !newText || btnLoading"
                        :btnLoading="btnLoading"
                        @click="createNew"
                        style="color: white !important;"
                        v-if="!id"
                    >
                        Создать новость
                    </v-btn>
                    <v-btn
                        color="green"
                        :disabled="softType === null || !title || newType === null || !newText || btnLoading"
                        :btnLoading="btnLoading"
                        @click="updateNew"
                        style="color: white !important;"
                        v-else
                    >
                        Сохранить новость
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-container>
</template>

<script>
    import API from "@/axios/api";
    import textWysiwygEditorField from "./text-wysiwyg-editor-field.vue";

    export default {
        name: "New",
        components: {
            textWysiwygEditorField,
        },
        data() {
            return {
                id: null,
                softType: null,
                softTypes: [],
                title: '',
                menu: false,
                publicationDate: new Date(),
                minDate: new Date().toISOString().substr(0, 10),
                newType: null,
                newTypes: [
                    { name: 'Новость/статья', id: 0 },
                    { name: 'Обновление (ченджлог, хистори)', id: 1 },
                ],
                newText: '',
                picture: '',
                important: false,
                btnLoading: false,
                formLoading: false,
                keyCrutch: 0,
            }
        },
        async activated() {
            this.formLoading = true;
            this.$store.commit('setCrumbs', [
                {text: 'main', disabled: false, to: '/', exact: true},
                {text: 'news', disabled: false, to: '/news', exact: true},
                {text: 'new', disabled: true},
            ])
            this.id = null;
            this.publicationDate = new Date();
            this.softType = null;
            this.newType = null;
            this.important = false;
            this.title = '';
            this.newText = '';
            this.picture = '';
            if (this.$route.params.id !== 'null') {
                this.id = this.$route.params.id;
                await this.getNew();
            }
            this.formLoading = false;
            this.keyCrutch++;
        },
        async mounted() {
            try {
                const response = await API.get('news/public_projects')
                this.softTypes = response.data.data
            } catch (error) {
                console.error(error)
                this.$store.commit('showSnackbar', {
                    color: 'error',
                    text: 'Ошибка при получении списка софтов',
                })
            }
        },
        methods: {
            updateDate(date) {
                this.publicationDate = new Date(date);
            },

            addPicture() {
                this.$refs.fileInput.click();
            },

            onFileChange(event) {
                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    const maxSizeInBytes = 5 * 1024 * 1024;
                    if (file.size > maxSizeInBytes) {
                        this.$store.commit('showSnackbar', {
                            color: 'error',
                            text: 'Максимальный размер изображения - 5Мб',
                        })
                        return;
                    } else {
                        reader.onload = (e) => {
                            const base64String = e.target.result;
                            this.picture = base64String;
                        };
                    }
                    reader.readAsDataURL(file);
                }
            },

            formattedDateForRequest(date) {
                const [year, month, day] = date.toISOString().substr(0, 10).split('-');
                return `${day}-${month}-${year}`
            },

            async createNew() {
                this.formLoading = true;
                await API.post('news/create', {
                    date: this.formattedDateForRequest(this.publicationDate),
                    soft_type: this.softType,
                    news_type: this.newType,
                    important: this.important,
                    lit: this.title,
                    text: this.newText,
                    image: this.picture ? this.picture : null,
                }).then((response) => {
                    console.log(response.data);
                    this.$store.commit('showSnackbar', {
                        color: 'success',
                        text: 'Новость запланирована',
                    })
                })
                .catch((error) => {
                    console.error(error);
                    this.$store.commit('showSnackbar', {
                        color: 'error',
                        text: 'Новость не запланирована',
                    })
                });
                this.$router.push({ name: 'News' });
            },

            async getNew() {
                try {
                    const response = await API.get(`news/${this.id}`);
                    this.publicationDate = new Date(response.data.data.date);
                    this.softType = response.data.data.soft_type;
                    this.newType = response.data.data.news_type;
                    this.important = response.data.data.important;
                    this.title = response.data.data.title;
                    this.newText = response.data.data.content;
                    this.picture = response.data.data.image;
                } catch (error) {
                    console.error(error)
                    this.$store.commit('showSnackbar', {
                        color: 'error',
                        text: 'Ошибка при получении новости',
                    })
                }
            },

            async updateNew() {
                this.formLoading = true;
                await API.post(`news/${this.id}/update`, {
                    date: this.formattedDateForRequest(this.publicationDate),
                    soft_type: this.softType,
                    news_type: this.newType,
                    important: this.important,
                    lit: this.title,
                    text: this.newText,
                    image: this.picture ? this.picture : null,
                }).then((response) => {
                    console.log(response.data);
                    this.$store.commit('showSnackbar', {
                        color: 'success',
                        text: 'Новость обновлена',
                    })
                })
                .catch((error) => {
                    console.error(error);
                    this.$store.commit('showSnackbar', {
                        color: 'error',
                        text: 'Новость не обновлена',
                    })
                });
                this.$router.push({ name: 'News' });
            },
        },
        computed: {
            formattedDate() {
                return this.publicationDate.toLocaleDateString('ru-RU');
            },

            dateString: {
                get() {
                    return this.publicationDate.toISOString().substr(0, 10);
                },
                set(value) {
                    this.publicationDate = new Date(value);
                }
            }
        }
    }
</script>

<style scoped>

</style>